import { all, put, takeLatest } from 'redux-saga/effects';
import {
    GET_CATERING_DASHBOARD_SUMMARY,
    GET_CATERING_DASHBOARD_SUMMARY_FAILURE,
    GET_CATERING_DASHBOARD_SUMMARY_SUCCESS,
} from '../../../modules/constants';
import { defaultApi } from '../../../utils/axiosApi';

export function* handleGetCateringDashboardSummary({ payload }) {
    try {
        const url = `/albait/dashboard/catering-summary/${payload?.date ? `?date=${payload.date}` : ''
            }`;
        const response = yield defaultApi(url, 'GET');
        yield put({
            type: GET_CATERING_DASHBOARD_SUMMARY_SUCCESS,
            payload: { data: response.data },
        });
    } catch (err) {
        yield put({
            type: GET_CATERING_DASHBOARD_SUMMARY_FAILURE,
            payload: err,
        });
    }
}

export default function* root() {
    yield all([
        takeLatest(GET_CATERING_DASHBOARD_SUMMARY, handleGetCateringDashboardSummary),
    ]);
}
